import { Component, Input, OnInit,Inject, Renderer2,ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { PoolingPortalService } from '../../../services/pooling-portal.service';
import { NavigationService } from '../../../services/navigation.service';
import { DistributionDataService } from '../../../services/distributionData.service';
import { Subscription } from 'rxjs'; 
import { environment } from '../../../../environments/environment';
import { IMenuOption, IUserOption } from 'snl-complib';
import { UserTrackingService } from 'src/app/services/userTracking.service';
import { VesselsService } from 'src/app/services/vessels.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent implements OnInit {

  public profile:any;

  @Input() navigationUrl :any;
  @Input() displayName :any;
  @Input() iRole :any;
  @Input() partner :any;
  @Input() fleets :any;
  
  public isCollapsed:boolean = false;
  public owners:[];
  menuOptions: IMenuOption[] = [];
 
  signOutOption: IMenuOption = {
    iconName: 'fa-solid fa-sign-out',
    displayName: 'Sign Out',
    selected: false,
    path: '',
  };
  userOption: IUserOption = {
    displayName: "",
    designation: "",
    initials: "",
  };
  environmentType:"prod" | "dev" | "uat" = environment.navType as "prod" | "dev" | "uat";
  selectedFleet: any[];
  subscription: Subscription;
  fleet: any;
  fleetOptions: any;
  defaultselectedFleet: any = [];
  constructor(private router: Router,
    private navService: NavigationService,
    private _poolingPortalService: PoolingPortalService,
    private _distributionDataService: DistributionDataService,
    private _vesselService:VesselsService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private _userTrackingService: UserTrackingService
    ) {}

  ngOnInit() {
    this.loadMenuOption(this.navigationUrl);
    this.selectedFleet= (this.fleets?.length > 0 ) ? this.fleets[0] : '';
    this.fleetOptions = this.fleets.map((name)=>({
      id: name,
      name: name,
    }));
    this.defaultselectedFleet.push(this.fleetOptions[0]);
    this._poolingPortalService.updateFleetValue(this.selectedFleet);
    this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        this.fleet = fleet;
        this.getOwnerList();
      }
    )
  }

  getOwnerList() {
    this._distributionDataService.getOwnerList(this.fleet)
      .subscribe({
        next: (res:any) => {
          this.owners = res.data.getOwnersList.data;
          this.userOption  = {
            "displayName": this.displayName,
            "designation":  (this.iRole == 1) ? 'Pool Manager': this._poolingPortalService.getVslOwnerLabel(this.partner,this.owners),
            "initials": ""
          }
        }
    });
  }

  loadMenuOption(navigationUrl:string){
    this.menuOptions = [
      {
        "iconName": "fa-solid fa-border-all",
        "displayName": "Dashboard",
        "selected": this.menuselected(navigationUrl,'/dashboard'),
        "path": 'dashboard' 
      },
      {
        "iconName": "fa-solid fa-book-open",
        "displayName": "Distribution",
        "selected": this.menuselected(navigationUrl,'/distribution'),
        "path": 'distribution'
      }
    ]    

    if(this.iRole == 1){
      this.menuOptions = [
        {
          "iconName": "fa-solid fa-border-all",
          "displayName": "Dashboard",
          "selected": this.menuselected(navigationUrl,'/dashboard'),
          "path": 'dashboard' 
        },
        {
          "iconName": "fa-solid fa-book-open",
          "displayName": "Distribution",
          "selected": this.menuselected(navigationUrl,'/distribution'),
          "path": 'distribution'
        },
        /* {
          "iconName": "fa-regular fa-clock",
          "displayName": "Fleet List",
          "selected": this.menuselected(navigationUrl,'fleetlist'),
          "path": "fleetlist"
        }, */
         {
          "iconName": "fa fa-ship",
          "displayName": "Fleet Management",
          "selected": this.menuselected(navigationUrl,'fleetmanagement'),
          "path": "fleetmanagement"
        }
      ]  
    }
    this.signOutOption = {
      "iconName": "fa-solid fa-sign-out",
      "displayName": "Sign Out",
      "selected": false,
      "path": "logout"
    }
  }
  
  public menuselected(select:string,menu:string){
    if(select?.includes(menu)){
      return true;
    }
    return false;
  }

  public selectedOption(event:any){
    this._vesselService.storegetPoolData = [];
    this._vesselService.storePoolval = '';
    this._vesselService.saveSelectedTab.next(false);
    if(event.option.path == 'logout'){
      this._userTrackingService.updateUserTrackingLogout().subscribe({
        next: (res:any) => { this.navService.logout(); },
        error: (error) => { this.navService.logout(); }
      });
    }
    else if(event.option.path &&  event.option.path != 'logout'){ 
      //this.loadMenuOption('/'+event.option.path);
      this.router.navigate([event.option.path]);
    }
  }
  public navigationCollapse(event: Event){
    this.isCollapsed = !this.isCollapsed;
    if (this.isCollapsed) {
      this.renderer.addClass(this.document.body, 'leftbar-collapsed');
    } else {
      this.renderer.removeClass(this.document.body, 'leftbar-collapsed');
    }
    this.navService.isNavigationCollapseSet(this.isCollapsed);
  }
  switchFleet(fleet){
    // this._distributionDataService.checkScrubberTabClicked.next(false);
    this._poolingPortalService.updateFleetValue(fleet);
    this._distributionDataService.changeFleet.next(true);
   
  }
}
